const DateFormatter = (inputDate, format = 'DEFAULT') => {
    
    let utcDate = '';

    if(inputDate instanceof Date) {
        utcDate = inputDate;
    } else if (typeof inputDate === 'string') {
        utcDate = new Date(inputDate)
    } else {
        return '';
    }

    //Check if it's a valid date value
    if (isNaN(utcDate.getTime())) {
        return '';
    }

    //Predefined formats
    let options = {};
    let prefix = '';
    let suffix = '';
    let separator = ', ';

    switch (format) {
        case 'GENERATED':
            options = {
                day: '2-digit', month: '2-digit', year: '2-digit', hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true
            };
            prefix = 'Generado el ';
            separator = 'a las  ';
            break;
        case 'FULL_GENERATED':
            options = {
                day: '2-digit', month: 'long', year: 'numeric', hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true
            };
            prefix = 'Generado el ';
            separator = ', a las ';
            break;
        case 'FULL_DATE':
            options = {
                dateStyle: 'full', timeStyle: 'medium' //Examples: miercoles, 05 de octubre, 2:48:29 p.m. CST
            }
            prefix = 'Última actualización: ';
            break;
        case 'COMPACT_DATE':
            options = {
                day: '2-digit', month: 'short', hour: 'numeric', minute: '2-digit', hour12: true
            };

            break;
        case 'SHORT_LABEL':
            options = {
                day: '2-digit', month: 'short'
            }
            
            break;
        case 'DEFAULT':
            default:
                options = {
                day: '2-digit', month: '2-digit', year: '2-digit', hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true
            };
            break;
        }

        //Base options
        const baseOptions = {
            timeZone: 'America/Mexico_City',
            locale: 'es-MX',
            timeZoneName: undefined,
            ...options
        };

        const formatter = new Intl.DateTimeFormat(baseOptions.locale, baseOptions);
        let result = formatter.format(utcDate);

        if(format === 'GENERATED' && result.includes(', ')){
            result = result.replace(' ', separator);
        }

        if (format === 'FULL_GENERATED' && result.includes(', ')) {
            result = result.replace(', ', separator)
        }

        //Apply a specific format to achieve '31 Oct, 10:30 am'
        if (format === 'COMPACT_DATE') {
            const date = new Intl.DateTimeFormat('en-GB', {day: '2-digit', month: 'short'}).format(utcDate);
            const time = new Intl.DateTimeFormat('en-GB', {hour: 'numeric', minute: '2-digit', hour12: true}).format(utcDate);
            result = `${date}, ${time}`;
        }

        return prefix + result + suffix;
}

export default DateFormatter; 